// Swagger doc: https://testapi.livexcollect.com.au/swagger/index.html

export const apiConfig = {
        baseURL: process.env.REACT_APP_API_URL.trim() // remove any whitespace
    }